export const LogoMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
    <rect x="2.5" y="2.5" width="43" height="43" rx="8" fill="#071838" stroke="#C5A059" strokeWidth="1.5" />
    <path d="M24 8.5 L39.5 24 L24 39.5 L8.5 24 Z" stroke="#C5A059" strokeWidth="1.4" />
    <circle cx="18.5" cy="18.5" r="1.9" fill="#C5A059" />
    <circle cx="24" cy="24" r="1.9" fill="#C5A059" />
    <circle cx="29.5" cy="29.5" r="1.9" fill="#C5A059" />
    <path
      d="M13 33.5c2.4-1.6 4.8-1.6 7.2 0s4.8 1.6 7.2 0 4.8-1.6 7.2 0"
      stroke="#C5A059"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </svg>
);

export default function Logo({ compact = false }) {
  return (
    <span className="flex items-center gap-3" data-testid="brand-logo">
      <LogoMark className="h-9 w-9 sm:h-10 sm:w-10 shrink-0" />
      {!compact && (
        <span className="leading-none">
          <span className="block font-serif text-xl font-semibold tracking-[0.18em] text-white">DICE</span>
          <span className="mt-1 block font-mono text-[0.55rem] uppercase tracking-[0.42em] text-[#C5A059]">
            International
          </span>
        </span>
      )}
    </span>
  );
}
